import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import Calculator from '../components/Calculator';
import FinalCTA from '../components/FinalCTA';
import Partners from '../components/Partners';
import Testimonials from '../components/Testimonials';
import WhyChooseUs from '../components/WhyChooseUs';

const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
      <Features />
      <HowItWorks />
      <Calculator />
      <Partners />
      <Testimonials />
      <WhyChooseUs />
      <FinalCTA />
    </>
  );
};

export default HomePage;